import { createSlice } from "@reduxjs/toolkit";

const initialorganizationClassificationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  organizationClassificationForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  organizationClassificationFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminOrganizationClassificationSlice = createSlice({
  name: "organizationClassification",
  initialState: initialorganizationClassificationState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getorganizationClassificationById
    organizationClassificationFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.organizationClassificationForEdit =
        action.payload.organizationClassificationForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findorganizationClassification
    organizationClassificationsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    organizationClassificationReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    organizationClassificationFiles: (state, action) => {
      state.organizationClassificationFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    organizationClassificationFilesFetched: (state, action) => {
      state.organizationClassificationFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
